import moment from 'moment';

export const emptyStallCard = {
  dateRange: { startDate: null, endDate: null },
  entireEvent: false,
  name: '',
  price: '',
  pricing: '',
  flippingDisabled: false,
  stallsForThisRate: []
};

export const emptyRvCard = {
  price: '',
  pricing: '',
  rvLotId: '',
  spots: [],
  flippingDisabled: false,
  dateRange: { startDate: null, endDate: null }
};

export const emptyQuestionCard = {
  id: 1,
  question: '',
  answerOptions: [{ id: 1, text: null }],
  questionType: 'singleSelection',
  required: false,
  listOrder: 0
};

const getAddOns = addOnProducts =>
  addOnProducts.map(addonProduct => ({
    addOnProductId: addonProduct.id,
    id: addonProduct.addOn.id,
    price: addonProduct.price,
    name: addonProduct.addOn.name,
    unitName: addonProduct.addOn.unitName,
    booked: addonProduct.booked,
    disabled: addonProduct.disabled
  }));

export const initialValues = event => ({
  hasStalls: !!event?.stallProducts?.length || false,
  hasRvs: !!event?.rvProducts?.length || false,
  step: 'details',
  eventDates: { startDate: event?.startDate || null, endDate: event?.endDate || null },
  protectedDates: {
    startDate: event?.protectedStartDate ? moment(event.protectedStartDate).format('MM/DD/YYYY') : null,
    endDate: event?.protectedEndDate ? moment(event?.protectedEndDate).format('MM/DD/YYYY') : null
  },
  bookingWindow: {
    startDate: event?.openDate ? moment(event.openDate).format('MM/DD/YYYY') : null,
    endDate: event?.closeDate ? moment(event.closeDate).format('MM/DD/YYYY') : null
  },
  stallQuestions: mapProductQuestions(event, 'stallQuestions'),
  rvQuestions: mapProductQuestions(event, 'rvQuestions'),
  openTime: event?.openDate ? moment(event.openDate).format('HH:mm') : '00:00',
  closeTime: event?.closeDate ? moment(event.closeDate).format('HH:mm') : '23:59',
  checkInTime: event?.checkInTime || '15:00',
  checkOutTime: event?.checkOutTime || '12:00',
  eventDescription: event?.description || '',
  stalls: mapStalls(event),
  eventName: event?.name || '',
  addOns: event?.addOnProducts?.length ? getAddOns(event.addOnProducts) : [],
  requiredAddOns: event?.requiredAddOns?.length ? event?.requiredAddOns : [],
  rvs: mapRVs(event),
  venueAgreement: event?.venueAgreement?.id || '',
  venueMap: event?.venueMap?.id || null,
  validSections: event?.validSections || null,
  isLoading: false,
  agreements: event?.agreements || [],
  allowDefferedEnabled: event?.isGroupCodeRequired === true || event?.isGroupCodeRequired === false || false,
  renterGroupCodeMode: event?.isGroupCodeRequired === true ? 'secured' : event?.isGroupCodeRequired === false ? 'unsecured' : '',
  hasOrders: event?.orders.length || 0,
  allowAddOnOnlyOrder: event?.allowAddOnOnlyOrder || false,
  password: '',
  protectedEvent: event?.protectedEvent || false,
  hidden: event?.hidden || false,
  protectedStartTime: event?.protectedStartDate ? moment(event.protectedStartDate).format('HH:mm') : '00:00',
  protectedEndTime: event?.protectedEndDate ? moment(event.protectedEndDate).format('HH:mm') : '23:59',
  protectedEntireEvent: false,
  eventLinks: event?.eventLinks?.length ? event?.eventLinks : [],
  phone: event?.phone || ''
});

const mapProductQuestions = (event, productQuestions) => {
  return event && event[productQuestions] ? mapAnswers(event[productQuestions]) : [];
};

const mapAnswers = questions => {
  const mappedAnswers = questions.map(question => {
    question.idInDb = +question.id;
    const answerOptions = question.answerOptions.map((answer, index) => ({ id: index + 1, text: answer }));
    return { ...question, answerOptions };
  });

  return mappedAnswers;
};

const mapStalls = event =>
  event?.stallProducts.map(stallProduct => {
    (stallProduct.dateRange = {
      startDate: stallProduct.startDate,
      endDate: stallProduct.endDate
    }),
      (stallProduct.entireEvent = isEntireEvent(event, stallProduct)),
      (stallProduct.flippingDisabled = !stallProduct.stallFlip),
      (stallProduct.pricing = stallProduct.nightly ? 'nightly' : 'flat'),
      (stallProduct.stallsForThisRate = stallProduct.stalls.map(stall => stall.id)),
      (stallProduct.initialStallsForThisRate = stallProduct.stalls.map(stall => stall.id)),
      (stallProduct.bookedStalls = stallProduct.bookedStalls.map(stall => stall));
    return stallProduct;
  });

const mapRVs = event => {
  return event?.rvProducts ? mapRVLotsInfo(event.rvProducts, event) : [];
};

const mapRVLotsInfo = (rvProducts, event) => {
  return rvProducts.map(rvProduct => {
    rvProduct.rvLotId = rvProduct.rvLot.id;
    rvProduct.dateRange = { startDate: rvProduct.startDate, endDate: rvProduct.endDate };
    rvProduct.entireEvent = isEntireEvent(event, rvProduct);
    rvProduct.pricing = rvProduct.nightly ? 'nightly' : 'flat';
    rvProduct.spots = rvProduct.rvSpots.map(rvSpot => rvSpot.id);
    rvProduct.flippingDisabled = !rvProduct.rvFlip;
    return rvProduct;
  });
};

const isEntireEvent = (event, product) => {
  const hasEventStartDate = event.startDate === product.startDate;
  const hasEventEndDate = event.endDate === product.endDate;
  return hasEventStartDate && hasEventEndDate;
};
